//const url = 'http://localhost:8003';
const url = 'https://api-experienciazermat.azurewebsites.net';


const urlF = "https://www.experienciazermat.com";
const pathImg = "https://zermatinternal.com:3030/ImageUpload/UploadZMT/";

export default {url, urlF, pathImg}